import { $history, SUPPORTED_LANGS, isDevelopment } from '@rst/libs-ts'
import { createEvent, createStore } from 'effector'

const getLocaleFromPathname = ({
	pathname,
	langs,
}: {
	pathname: string
	langs: string[]
}) => {
	if (isDevelopment) {
		if (
			/^\/\w\w(\/|$)/i.test(pathname) &&
			langs.includes(pathname.slice(1, 3))
		) {
			return pathname.slice(1, 3)
		}
		return null
	} else {
		if (
			window.__setting__?.lang_setting?.type === 'path' &&
			/^\/\w\w(\/|$)/i.test(pathname) &&
			langs.includes(pathname.slice(1, 3))
		) {
			return pathname.slice(1, 3)
		}
		if (window.__setting__?.lang_setting?.type === 'subdomain') {
			const parts = window.location.host.split('.')
			if (parts.length === 2 || parts[0].length !== 2) return null
			return parts[0]
		}

		return null
	}
}

const $locale = createStore(
	getLocaleFromPathname({
		pathname: $history.getState().pathname,
		langs: Object.keys(SUPPORTED_LANGS),
	}) || 'ru'
)

const updateConnectedLangs = createEvent<string[]>()
const $connectedLangs = createStore(Object.keys(SUPPORTED_LANGS)).on(
	updateConnectedLangs,
	(prevLangs, langs) => {
		if (langs?.length) return langs
		return prevLangs
	}
)

export { $locale, getLocaleFromPathname, $connectedLangs, updateConnectedLangs }
